const ID_TIPO_MODULO_CP = 13;
const ID_TIPO_MODULO_CD = 16;
const ID_URGENCIA = 4;
const ID_PACIENTE_DOMICILIO_NO = 6;
const ID_TIPO_PROFESIONAL_MEDICO = 1;
const ID_TIPO_PROFESIONAL_NUTRICIONISTA = 3;

export const aplicarReglaFase = ({
    importes,
    fase,
    idTipoModulo,
    idTipoProfesional,
    idComboVisitaValorFormaVisita,
    idComboVisitaValorPacienteDomicilio,
    honorarioPresencial,
    honorarioVirtual
}) => {
    const programaEsCPCD = idTipoModulo === ID_TIPO_MODULO_CP || idTipoModulo === ID_TIPO_MODULO_CD;
    const aplicaPorTipoProfesional = idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO || idTipoProfesional === ID_TIPO_PROFESIONAL_NUTRICIONISTA;
    if (programaEsCPCD || fase !== 3 || !aplicaPorTipoProfesional) {
        return importes;
    }

    const pacienteNoEnDomicilio = idComboVisitaValorPacienteDomicilio === ID_PACIENTE_DOMICILIO_NO;
    if (pacienteNoEnDomicilio) {
        return {
            presencial: 0,
            virtual: 0,
            tramo: 0,
            cambioSonda: 0,
            capacitacion: 0,
            emergencia: 0,
            extraDuracion: 0,
            importeTotal: 0
        };
    }

    const esUrgencia = idComboVisitaValorFormaVisita === ID_URGENCIA;
    const ajustado = esUrgencia
        ? { ...importes, presencial: honorarioPresencial || 0, virtual: 0 }
        : { ...importes, presencial: 0, tramo: 0, virtual: honorarioVirtual || 0 };

    ajustado.importeTotal =
        (ajustado.presencial ?? 0) +
        (ajustado.virtual ?? 0) +
        (ajustado.tramo ?? 0) +
        (ajustado.cambioSonda ?? 0) +
        (ajustado.capacitacion ?? 0) +
        (ajustado.emergencia ?? 0) +
        (ajustado.extraDuracion ?? 0);

    return ajustado;
};